<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Add New Video
        <div class="page__header-subtitle">
          Save, share and publish video files
        </div>
      </div>
      <div class="page__header-tools"></div>
    </div>
    <div class="page__body">
      <form ref="form" autocomplete="off" @submit.prevent="addNewVideo()">
        <hr />
        <b-row class="form__contents">
          <b-col>
            <b-row>
              <b-col>
                <div
                  class="form__file-drop"
                  @click="
                    $refs.videoInput.$el
                      .querySelector('input[type=file]')
                      .click()
                  "
                >
                  <div class="form__file-text">
                    <img src="../../assets/upload-video.svg" />
                    <p>Drop your video here.</p>
                    <p>
                      or
                      <span class="file__browse">Browse</span>
                    </p>
                  </div>
                  <b-form-file
                    class="form___file"
                    v-model="file"
                    ref="videoInput"
                    :state="Boolean(file)"
                    size="lg"
                    accept=".mp4, .wav, .mov"
                    @change="readFile($event)"
                  ></b-form-file>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Drag and drop video file or insert video URL below"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="url"
                    :required="!fileAccepted"
                    :disabled="fileAccepted"
                    size="sm"
                    trim
                    maxlength="200"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="page__filename">
              <span class="file__name">{{ fileName }}</span>
              <i v-if="fileAccepted" class="icon-checkmark2 file__accept"></i>
              <i
                v-if="file && !fileAccepted"
                class="icon-cancel-circle file__reject"
              ></i>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-form-group
                  label="Exercise Title"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="title"
                    required
                    size="sm"
                    placeholder="e.g.: High Knees by The Active Helath"
                    trim
                    maxlength="45"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              ><b-col
                ><b-form-group
                  label="Upload Thumbnail"
                  label-size="sm"
                  label-class="form__label"
                  ><span class="form__label-star">*</span>
                  <b-row class="w-100">
                    <b-col cols="4">
                      <b-img
                        :src="thumbnailSrc"
                        height="50"
                        width="100"
                        left
                      ></b-img>
                    </b-col>
                    <b-col cols="8">
                      <b-button
                        size="sm"
                        variant="success"
                        @click="
                          $refs.thumbnailInput.$el
                            .querySelector('input[type=file]')
                            .click()
                        "
                        >Select Files</b-button
                      >
                      <b-form-file
                        class="form___file"
                        ref="thumbnailInput"
                        v-model="thumbnailFile"
                        :state="Boolean(thumbnailFile)"
                        placeholder="Select Files"
                        size="sm"
                        accept="image/*"
                        :required="!selectedThumbnail"
                        @input="handleImageChange($event)"
                      ></b-form-file>
                    </b-col>
                  </b-row>
                </b-form-group> </b-col
            ></b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Exercise Type"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="type"
                    required
                    size="sm"
                    placeholder="Exercise Type"
                    trim
                    maxlength="15"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Video Intensity"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span><br>
                  <b-row>
                  <b-form-input
                    id="range-1"
                    v-model="intensity"
                    type="range"
                    min="1"
                    max="20"
                    step="0.5"
                    size="sm"
                    ref="videoIntensity"
                    class="intensity d-flex col-10 pl-3"
                  >
                  </b-form-input>
                  <div class="video-intensity-val d-flex col-2">
                    {{ intensity }}
                  </div>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Description"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-textarea
                    v-model="description"
                    required
                    size="sm"
                    placeholder="Description"
                    trim
                    rows="3"
                    maxlength="190"
                    no-resize
                    class="textareaAV"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group class="video__checkbox"
              label="Video stitch compatible?"
              label-size="sm"
              label-class="form__label"
            >

                <b-form-checkbox
                  v-b-tooltip.hover
                  :title="isStitchable ? 'Stitchable' : 'Unstitchable'"
                  v-model="isStitchable"
                  switch
                  size="sm"
                ></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row></b-row>
        <hr />
        <b-row>
          <b-col cols="9">
            <p>*Video files accepted formats .mp4 .wav .mov</p>
          </b-col>
          <b-col cols="3">
            <b-button
              class="form__button_left"
              size="sm"
              variant="light"
              @click="cancel()"
              >Cancel</b-button
            >
            <b-button
              class="form__button_right"
              size="sm"
              variant="success"
              :disabled="addingVideo"
              type="submit"
              >Add Video</b-button
            >
          </b-col>
        </b-row>
      </form>
      <div class="form-hidden-video">
        <video id="hidden__video" :src="url" hidden controls></video>
      </div>
    </div>
    <loader v-if="addingVideo"></loader>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/videosView");

import S3Url from "../s3upload/getSignedURL.js";
import toast from "../toaster.js";

export default {
  data: function() {
    return {
      file: null,
      url: null,
      title: null,
      type: null,
      intensity: 1,
      description: null,
      duration: null,
      fileName: null,
      fileContent: null,
      thumbnail: null,
      selectedThumbnail: null,
      thumbnailFile: null,
      thumbnailSrc: null,
      thumbnailURL: null,
      fileAccepted: false,
      addingVideo: false,
      isStitchable: false,
    };
  },

  methods: {
    ...mapActions(["addVideo", "getS3Cred"]),
    readFile(e) {
      this.url = "";
      const reader = new FileReader();
      let file =
        e.type === "change" ? e.target.files[0] : e.dataTransfer.files[0];
      this.fileName = file.name;

      if (
        file.type === "video/mp4" ||
        file.type === "video/wav" ||
        file.type === "video/quicktime"
      ) {
        this.fileAccepted = true;

        reader.onload = (e) => {
          this.fileContent = e.target.result;
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.fileAccepted = false;
        this.$refs["videoInput"].reset();
        this.fileName = null;
        toast.showToasts(this, "Please input valid video", "danger");
      }
    },
    handleImageChange(e) {
      this.selectedThumbnail = e || this.selectedThumbnail;
      this.thumbnailFile = this.selectedThumbnail;

      this.createBase64Img(this.thumbnailFile);
    },

    createBase64Img(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnail = e.target.result;
        this.thumbnailSrc =
          "data:image/jpeg;base64," +
          btoa(
            new Uint8Array(this.thumbnail).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      };
      reader.readAsArrayBuffer(file);
    },

    async addNewVideo() {
      this.addingVideo = true;

      await this.getS3Cred();
      let s3Cred = this.$store.state.admin.videosView.s3Cred;
      //upload thumbnail to s3

      let thumbResponse = await S3Url.getS3Url(
        s3Cred,
        this.thumbnailFile,
        this.thumbnail,
        "thumbnails"
      );
      this.thumbnailURL = thumbResponse.Location;
      //upload video to s3
      if (this.file) {
        let response = await S3Url.getS3Url(
          s3Cred,
          this.file,
          this.fileContent,
          "videos"
        );
        this.url = response.Location;

        this.getVideoDuration();
      } else {
        this.getVideoDuration();
      }
    },

    getVideoDuration() {
      let video = document.getElementById("hidden__video");

      if (!this.file && video.error) {
        toast.showToasts(this, "Please enter valid video url", "danger");
        this.addingVideo = false;
        return;
      }
      if (video.duration) {
        this.prepareDataAndAdd(video.duration);
      } else {
        video.addEventListener("loadedmetadata", (event) => {
          var durationSecs = event.target.duration;

          this.prepareDataAndAdd(durationSecs);
        });
      }
    },

    prepareDataAndAdd(duration) {
      const videoData = {
        title: this.title,
        videoURL: this.url,
        thumbnail: this.thumbnailURL,
        type: this.type,
        duration: duration,
        intensity: this.intensity,
        description: this.description,
        isStitchable: this.isStitchable
      };

      this.addVideo({ vm: this, data: videoData }).then(() => {
        this.addingVideo = false;
      });
    },

    cancel() {
      this.$router.push("/admin/videos");
    },
  },
};
</script>

<style scoped>
.video__checkbox{
  display: flex;
  column-gap: 1em;
}
.textareaAV {
  height: 92px;
}
hr {
  margin: 3px !important;
}

.form__contents {
  min-height: 380px;
}

.form___file {
  opacity: 0;
  height: 100% !important;
  width: 100%;
  position: relative;
}

.form__file-drop {
  background: aliceblue;
  border: 2px dashed powderblue;
  height: 295px;
  width: 100%;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  /* padding: 48px 0; */
  margin: 2% 0;
}

.form__file-text {
  position: absolute;
  top: 27%;
  left: 33%;
}

.file__browse {
  color: #28c76f;
}

img {
  margin-bottom: 5px;
}
p {
  margin: 0;
}

.file__accept {
  background: #28c76f;
  border-radius: 10px;
  border: 1px solid black;
  float: right;
}

.file__reject {
  background: red;
  border-radius: 10px;
  border: 1px solid black;
  float: right;
}

.file__name {
  width: 96%;
  display: flex;
  float: left;
}

.form-hidden-video {
  height: 0;
  width: 0;
}
.video-intensity-val {
  float: right;
  width: 48%;
  font-size: 16px;
  color: #73bc44;
  font-weight: bold;
}
</style>
